import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
    const [fine, setFine] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const rx = useSpring(x, { stiffness: 380, damping: 34, mass: 0.55 });
    const ry = useSpring(y, { stiffness: 380, damping: 34, mass: 0.55 });

    useEffect(() => {
        // détection par vrai mouvement de souris — les media queries
        // (pointer:fine) échouent sur certains laptops hybrides/tactiles
        const enable = () => {
            setFine(true);
            document.documentElement.classList.add("rec-cursor");
        };
        const disable = () => {
            setFine(false);
            document.documentElement.classList.remove("rec-cursor");
        };
        const move = (e) => {
            if (e.pointerType === "mouse") enable();
            else if (e.pointerType === "touch") disable();
            x.set(e.clientX);
            y.set(e.clientY);
        };
        window.addEventListener("pointermove", move);
        return () => {
            window.removeEventListener("pointermove", move);
            disable();
        };
    }, [x, y]);

    if (!fine) return null;

    return (
        <>
            {/* REC button — camera record style, follows the pointer (taille fixe, pas de grossissement) */}
            <motion.div
                className="fixed left-0 top-0 z-[100] pointer-events-none"
                style={{ x, y }}
            >
                <div className="relative -translate-x-1/2 -translate-y-1/2">
                    {/* red record dot — reste toujours à la même taille */}
                    <span className="block h-4 w-4 rounded-full bg-blood shadow-[0_0_18px_rgba(225,6,44,1)] ring-2 ring-blood/50" />
                    {/* REC pill */}
                    <span className="absolute left-4 top-1/2 flex -translate-y-1/2 items-center gap-1.5 rounded-full border border-blood/70 bg-ink/90 px-2.5 py-1 font-mono text-[9px] font-bold tracking-[0.25em] text-blood shadow-[0_0_16px_rgba(225,6,44,0.35)]">
                        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-blood" />
                        REC
                    </span>
                    {/* anneau d'animation autour du point REC */}
                    <span className="absolute inset-0 animate-pulse-ring rounded-full border border-blood/70" />
                </div>
            </motion.div>
            {/* trailing ring discret */}
            <motion.div
                data-testid="custom-cursor"
                className="fixed left-0 top-0 z-[99] pointer-events-none"
                style={{ x: rx, y: ry }}
            >
                <div className="h-9 w-9 -translate-x-1/2 -translate-y-1/2 rounded-full border border-blood/40" />
            </motion.div>
        </>
    );
}
